export enum ContentPage {
  HOME = 'HOME',
  WORKSPACE = 'WORKSPACE',
  DESIGNER = 'DESIGNER',
  ADMIN = 'ADMIN',
  DATA_SETTINGS = 'DATA_SETTINGS',
}
